export default "__VITE_ASSET__D8bLoX7u__"